var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeypad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86509 8.33867C9.86509 9.17435 9.21537 9.82407 8.37969 9.82407H2.02642C1.19073 9.82407 0.541016 9.17435 0.541016 8.33867V1.9854C0.541016 1.14972 1.19073 0.5 2.02642 0.5H8.37969C9.21537 0.5 9.86509 1.14972 9.86509 1.9854V8.33867Z",
    fill: "white",
    stroke: "#121212"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24.8242,
    width: 22,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.768066,
    y: 12.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.7681,
    y: 12.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.865,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.865,
    y: 0.5,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.7681,
    y: 12.8242,
    width: 9,
    height: 9,
    rx: 1.5,
    fill: "white",
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypad);
export default __webpack_public_path__ + "static/media/keypad.3516603e42a5235e514e2ebbb140b407.svg";
export { ForwardRef as ReactComponent };